import { apm } from '@elastic/apm-rum';
import { useEffect, useState } from 'react';

import { ApplicationStatus } from '../domain/types';
import { EventApplicationProgress, EventApplicationStatus } from '../helpers/gtm';
import useSettings from '../hooks/useSettings';
import { useAppSelector } from '.';

const useComponentTracker = (name: string, applicationStatus?: ApplicationStatus) => {
    const { applicationId } = useAppSelector((state) => state.application);
    const [transaction] = useState(() => apm.startTransaction(name, 'component'));
    const { countryCode } = useSettings();

    useEffect(() => {
        EventApplicationProgress(applicationId, name, countryCode);
        if (applicationStatus) {
            EventApplicationStatus(applicationId, name, countryCode, applicationStatus);
        }

        const isActive = !!transaction;
        transaction?.addLabels({
            applicationId: applicationId ?? '',
        });

        const endTransaction = () => {
            if (isActive) {
                transaction?.end();
            }
            window.removeEventListener('load', endTransaction);
        };

        if (document.readyState === 'complete') {
            endTransaction();
        } else {
            window.addEventListener('load', endTransaction);
        }

        return () => {
            endTransaction();
        };
    }, []);
};

export default useComponentTracker;
